var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-form-item", {
        attrs: { label: _vm.i18nt("designer.setting.htmlContent") },
      }),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { "label-width": "0" } },
        [
          _c("el-input", {
            staticClass: "html-content-editor",
            attrs: { type: "textarea", rows: 5 },
            model: {
              value: _vm.optionModel.htmlContent,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel, "htmlContent", $$v)
              },
              expression: "optionModel.htmlContent",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }